<template>
    <div v-if="canShow('调理方法') && info && (hasTiaoli || adjustmentFunList.length > 0)">
        <div class="tips"></div>

        <template v-if="hasTiaoli">
            <div class="sick-box">
                <div class="risk">调理原则</div>
            </div>
            <div class="assessment">
                <div class="adjustment-method-box tiaoli">
                    {{ info.jibing.tiaoli }}
                </div>
            </div>
        </template>

        <template v-if="adjustmentFunList.length > 0">
            <div class="sick-box">
                <div class="risk">调理方法</div>
            </div>
            <div class="assessment">
                <div class="adjustment-method-box">
                    <div class="adjustment-intro">
                        人体和自然是同步的，四季气候、阴阳消长不一样，身体的需求也完全不同，所以养生必须跟着季节变。
                    </div>
                    <div class="adjustment-intro">
                        目前正值{{ info.currentSeason }}，根据您的身体情况，推荐以下调理方案：
                    </div>

                    <div class="adjustment-item" v-for="(mod, modIndex) in adjustmentFunList" :key="modIndex">
                        <div class="item-title">{{ circleNum(modIndex) }} {{ mod.moduleName }}</div>
                        <template v-for="(item, itemIndex) in mod.items">
                            <div class="item-line" v-for="(val, valIndex) in item.values" :key="modIndex + '-' + itemIndex + '-' + valIndex">
                                <span class="label">{{ val.title }}：</span>{{ val.value }}
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { moduleMixin } from '../helpers';
import { mapState } from 'vuex';

const CIRCLE_NUMBERS = ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨'];

export default {
    name: 'AdjustmentFun',
    mixins: [moduleMixin],
    computed: {
        ...mapState('report', ['info']),
        hasTiaoli() {
            const info = this.info || {};
            return info.jibing && info.jibing.tiaoli;
        },
        adjustmentFunList() {
            const info = this.info || {};
            return Array.isArray(info.adjustmentFunList) ? info.adjustmentFunList : [];
        }
    },
    methods: {
        circleNum(index) {
            return CIRCLE_NUMBERS[index] || (index + 1) + '.';
        }
    }
};
</script>

<style lang="scss" scoped>
@import './AdjustmentFun.scss';
</style>
